export default __webpack_public_path__ + "img/img_joanna_wong-d35e724d61c6d4c7756188b14895ae2e.jpg";